import { gql } from '@/features/graphql/generated'

export const cartItemAddMutation = gql(/* GraphQL */ `
    mutation CartItemAdd($cartKey: ID, $itemAdd: CartItemAddInput!) {
        cartItemAdd(cartKey: $cartKey, itemAdd: $itemAdd) {
            key
            ...Cart
        }
    }
`)

export const cartItemRemoveMutation = gql(/* GraphQL */ `
    mutation CartItemRemove($cartKey: ID!, $itemUuid: ID!) {
        cartItemRemove(cartKey: $cartKey, itemUuid: $itemUuid) {
            ...Cart
        }
    }
`)

export const cartItemChangeQuantityMutation = gql(/* GraphQL */ `
    mutation CartItemChangeQuantity($cartKey: ID!, $changeQuantity: CartItemChangeQuantityInput!) {
        cartItemChangeQuantity(cartKey: $cartKey, changeQuantity: $changeQuantity) {
            ...Cart
        }
    }
`)

export const cartContainerItemAddMutation = gql(/* GraphQL */ `
    mutation CartContainerItemAdd($cartKey: ID, $containerItemAdd: CartContainerItemAddInput!) {
        cartContainerItemAdd(cartKey: $cartKey, containerItemAdd: $containerItemAdd) {
            key
            ...Cart
        }
    }
`)

export const cartContainerItemRemoveMutation = gql(/* GraphQL */ `
    mutation CartContainerItemRemove($cartKey: ID!, $itemUuid: ID!) {
        cartContainerItemRemove(cartKey: $cartKey, itemUuid: $itemUuid) {
            ...Cart
        }
    }
`)

export const cartContainerItemChangeQuantityMutation = gql(/* GraphQL */ `
    mutation CartContainerItemChangeQuantity(
        $cartKey: ID!
        $changeQuantity: CartContainerItemChangeQuantityInput!
    ) {
        cartContainerItemChangeQuantity(cartKey: $cartKey, changeQuantity: $changeQuantity) {
            ...Cart
        }
    }
`)
